import React from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import AboutMe from '../pages/AboutMe'
import ContactMe from '../pages/ContactMe'
import Home from '../pages/Home'
import MyWork from '../pages/MyWork'
import Resume from '../pages/Resume'
import Skills from '../pages/Skills'
import { AnimatePresence } from 'framer-motion';
import MyService from '../pages/MyService'

const AnimatedRoutes = ({ visible, setVisible }) => {
    const location = useLocation();

    return (
        <AnimatePresence exitBeforeEnter initial={false}>
            <Routes key={location.pathname} location={location}>
                <Route path="/" element={<Home visible={visible} setVisible={setVisible} />} />
                <Route path="/about" element={<AboutMe />} />
                <Route path="/skills" element={<Skills />} />
                <Route path="/resume" element={<Resume />} />
                <Route path="/work" element={<MyWork />} />
                <Route path="/service" element={<MyService />} />
                <Route path="/contact" element={<ContactMe />} />
            </Routes>
        </AnimatePresence>
    )
}

export default AnimatedRoutes